// Welsh (UK) translations - alias for cy
export const cyGB: Record<string, string> = {
  'menu.dashboard': 'Dangosfwrdd',
  'menu.customers': 'Cwsmeriaid',
  'menu.products': 'Cynhyrchion',
  'menu.users': 'Defnyddwyr',
  'menu.settings': 'Gosodiadau',
  'menu.logout': 'Allgofnodi',
  'dashboard.title': 'Dangosfwrdd',
  'dashboard.newOrder': 'Archeb newydd',
  'order.title': 'Archeb newydd',
  'order.customer': 'Cwsmer',
  'order.products': 'Cynhyrchion',
  'order.total': 'Cyfanswm',
  'users.title': 'Defnyddwyr',
  'users.name': 'Enw',
  'users.email': 'E-bost',
  'common.yes': 'Iawn',
  'common.no': 'Na',
  'common.cancel': 'Canslo',
  'common.save': 'Cadw',
  'common.search': 'Chwilio',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Mewngofnodi',
  'login.welcome': 'Croeso, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'E-bost',
  'signup.phone': 'Ffôn',
  'menu.reportsAndAccounting': 'Adroddiadau a Chyfrifeg',
  'menu.systemAndCommunication': 'System a Chyfathrebu',
};